// Define the initializeSwiper function
function initializeSwiper() {
  if (typeof Swiper !== "undefined") {
    new Swiper(".complementary_swiper", {
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 10,
    });
  }
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", initializeSwiper);

// Observe changes in the cart drawer

let previousValue = document.querySelector(".totals__total-value");
const targetElement = document.querySelector(".totals__total-value");

function checkForChanges() {
  const currentValue = document.querySelector(".totals__total-value");

  if (currentValue !== previousValue) {
    previousValue = currentValue;
    // console.log('Change detected in totals__total-value');
    initializeSwiper();
  }
}
setInterval(checkForChanges, 100);

document.addEventListener("DOMContentLoaded", function () {
  initializeSwiper();
});